import React, { useEffect, useState } from "react";
import styles from "./CaseStudeisDetail.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "configs/AppConfig";
import Loader from "components/page-content/common-component/Loader/Loader";
import MetaDetails from "components/meta-details/MetaDetails";
import { Helmet } from "react-helmet";
import SEO from "components/SEO/SEO";

function CaseStudiesDetail() {
  const { Slug } = useParams();
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [upcomingData, setUpcomingData] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState({ success1: false, success2: false });
  const [metaData, setMetaData] = useState();

  const fetchData = async () => {
    const response = await fetch(`${API_BASE_URL}pages/get/Slug/${Slug}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (data?.success) {
      setSuccess((prev) => ({ ...prev, success1: true }));
    }
    setData(data?.data[0]);
    console.log("data pages", data);

    if (data?.data?.[0]) {
      const pageData = data.data[0];
      setMetaData({
        pageTitle: pageData?.metatitle,
        description: pageData?.metadescription,
        pageKeyword: pageData?.metakeywords?.join(","),
      });
    }

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  const fetchList = async () => {
    const response = await fetch(
      `${API_BASE_URL}pages/get/all?category=670f4ed8c258c9679a93f38b`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    if (data?.success) {
      setSuccess((prev) => ({ ...prev, success2: true }));
    }
    setList(data?.data?.sort((a, b) => a.priority - b.priority));
    console.log("data pages", data);

    if (data?.data?.[0]) {
      const pageData = data.data[0];
      setMetaData({
        pageTitle: pageData?.metatitle,
        description: pageData?.metadescription,
        pageKeyword: pageData?.metakeywords?.join(","),
      });
    }

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  console.log("image value", data);

  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    if (success.success1 && success.success2) {
      setLoading(false);
    }
  }, [success]);

  useEffect(() => {
    fetchData();
  }, [Slug]);

  useEffect(() => {
    if (data && list?.length > 0) {
      const indexValue = list.findIndex((item) => item?._id == data?._id);
      console.log("index value", indexValue);
      let previous = Number(indexValue) - 1;
      let next = Number(indexValue) + 1;
      if (Number(indexValue) == 0) {
        previous = list?.length - 1;
      }
      if (Number(indexValue) == list?.length - 1) {
        next = 0;
      }
      setUpcomingData({
        previous: previous,
        next: next,
      });
    }
  }, [data, list]);

  const PreviousNext = ({ value, data }) => {
    console.log("data value is", data, upcomingData);
    return (
      <div
        onClick={() => navigate(`/case-studies/${data?.slug}`)}
        className={styles.previousNext}
      >
        <img src={data?.image} />
        <div className={styles.flexPortion}>
          <h2>{value}</h2>
          <h3>{data?.name}</h3>
        </div>
      </div>
    );
  };
  console.log(metaData, "case detail metaData");
  return (
    <>
      {metaData && <SEO seo={metaData && metaData} />}
      <MetaDetails
        title={data?.metatitle}
        description={data?.metadescription}
        keywords={data?.metakeywords?.join(", ")}
      />
      <Helmet>
        {/* Dynamically setting meta tags for this case study page */}
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={data?.metatitle} />
        <meta property="og:description" content={data?.metadescription} />
        <meta property="og:image" content={data?.image} />
      </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <div className="case-studies">
          <div className={styles.caseOuter}>
            <div className={styles.bannerSection}>
              <img src={data?.image} />
              <div className={styles.contents}>
                <h2>{data?.name}</h2>
                <div className={styles.itemsDiv}>
                  <div className={styles.yearDiv}>
                    <div className={styles.individual}>
                      <img src="/img/bodyshop/year-case.svg" />
                      <h4>Year</h4>
                    </div>
                    <h5>{data?.year}</h5>
                  </div>
                  <div className={styles.yearDiv}>
                    <div className={styles.individual}>
                      <img src="/img/bodyshop/location-case.svg" />
                      <h4>Location</h4>
                    </div>
                    <h5>{data?.location}</h5>
                  </div>
                  <div className={styles.yearDiv}>
                    <div className={styles.individual}>
                      <img src="/img/bodyshop/service-case.svg" />
                      <h4>Services</h4>
                    </div>
                    <h5>
                      {data?.services?.map((item) => (
                        <p>{item}</p>
                      ))}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.editorContent}>
              <div className={styles.leftDiv}>
                <div
                  // className={styles.htmlContent}
                  dangerouslySetInnerHTML={{ __html: data?.description }}
                ></div>
                {/* <div className="template5Div">
                  <h2>
                    This bodyshop is located at Mumbai-India catering to mass
                    segment products. The business was operational from the past
                    8 years.
                  </h2>
                  <div className="contentDiv5">
                    <h3>The Improvements:</h3>
                    <p>
                      During our initial assessment of this business, we have
                      identified several challenges
                    </p>
                    <ol>
                      <li>
                        <span>Stagnant business growth</span>
                      </li>
                      <li>
                        <span>
                          Declined sales of parts and labour
                          <br />
                        </span>
                      </li>
                      <li>
                        <span>
                          Customer complaints are high as 9%
                          <br />
                        </span>
                      </li>
                      <li>
                        <span>
                          Inferior repair quality
                          <br />
                        </span>
                      </li>
                      <li>
                        <span>
                          Very high vehicle Turn Around Time
                          <br />
                        </span>
                      </li>
                      <li>
                        <span>
                          Improper usage of consumables
                          <br />
                        </span>
                      </li>
                      <li>
                        <span>
                          Inadequate business intelligence of middle management
                          staff and technicians
                          <br />
                        </span>
                      </li>
                      <li>
                        <span>
                          Lack of key equipment
                          <br />
                        </span>
                      </li>
                      <li>
                        <span>Poor equipment maintenance</span>
                      </li>
                      <li>
                        <span>Infrastructural limitations</span>
                      </li>
                    </ol>
                    <h3>The Challenges:</h3>
                    <p>
                      The post we rectifying the infrastructural limitations the
                      repair quality and speed had commenced to improve. With
                      our robust and intense coaching and training program we
                      could witness growth in all business parameters
                    </p>
                    <p>
                      After our business process implementation over a period of
                      six months, the Bodyshop regained business stability.
                      Moreover, we could control the manpower attrition.
                    </p>
                    <p>
                      Currently, the Bodyshop meets its monthly business target
                      regularly and on their way to meet their business
                      potential and market share
                    </p>
                    <h3>Behind the scenes:</h3>
                    <p>
                      The management team was spontaneous in providing support
                      in terms of investing in infrastructure which included
                      some key equipment and processes along with investments in
                      quality manpower. Here we have initiated some longterm
                      business and customer retention measures at this site
                    </p>
                    <p>
                      he team rose up to the situation and quickly adopted the
                      changes, which resulted in meeting the business objectives
                      and employee and customer satisfaction
                    </p>
                  </div>
                </div> */}
              </div>
              <div className={styles.rightDiv}>
                <div className={styles.previousNextFlex}>
                  <PreviousNext
                    data={list[upcomingData?.previous]}
                    value="Previous"
                  />
                  <PreviousNext data={list[upcomingData?.next]} value="Next" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CaseStudiesDetail;
